import { reportScheduleByProjectQuery } from '@aims/shared/report-schedules/constants';
import ReportScheduleEditor from '@aims/shared/report-schedules/ReportScheduleEditor';
import { EyeOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Button, Divider, Skeleton, Tooltip } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import HolisticProjectReportsTabs from '../../../holistic-quarterly-reports/HolisticQuarterlyReportsTabs';

function ReportScheduleTab({ holisticProjectId, project }) {
  const {
    data: scheduleData,
    loading,
    refetch,
  } = useQuery(reportScheduleByProjectQuery, {
    variables: { holisticProjectId },
    skip: !holisticProjectId,
    fetchPolicy: 'network-only',
  });

  const schedule = useMemo(
    () => scheduleData?.reportScheduleByProject || null,
    [scheduleData],
  );

  const handleScheduleChange = useCallback(() => {
    refetch();
  }, [refetch]);

  const renderEntryActions = useCallback((record) => {
    if (!record.scheduledReportId) return null;
    return (
      <Tooltip title="View report">
        <Link to={`/scheduled-reports/review/${record.scheduledReportId}`}>
          <Button type="link" size="small" icon={<EyeOutlined />} />
        </Link>
      </Tooltip>
    );
  }, []);

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <>
      <ReportScheduleEditor
        holisticProjectId={holisticProjectId}
        schedule={schedule}
        loanDurationMonths={project?.loanTerm}
        onScheduleCreated={handleScheduleChange}
        onScheduleUpdated={handleScheduleChange}
        isActiveOnCreate
        renderEntryActions={renderEntryActions}
      />
      {!project?.reportScheduleId && (
        <>
          <Divider />
          <HolisticProjectReportsTabs
            holisticProjectId={holisticProjectId}
            baseUrl={`/holistic-project/view/${holisticProjectId}/reports`}
          />
        </>
      )}
    </>
  );
}

export default ReportScheduleTab;
